<rask-page pageTitle="Funktioner">
  @for (feature of currentUserFeatures; track feature) {
    <rask-container-block>
      <rask-header size="3">
        {{feature.name}}
      </rask-header>
      <ng-container>
        <div class="row">
          <p class="col-3">{{feature.description}}</p>
          <rask-checkbox class="col-3 activeCheckbox" [(ngModel)]="feature.selected" (ngModelChange)="onCheckedChange()" [disabled]="!canEdit(feature)"></rask-checkbox>
        </div>
      </ng-container>
    </rask-container-block>
  }
  <ng-container footerContent>
    <rask-save-button color="primary" (click)="save()" [disabled]="!canSave()"></rask-save-button>
  </ng-container>
</rask-page>
